import { render, staticRenderFns } from "./DispatchStatusSelect.vue?vue&type=template&id=4c5c839e&scoped=true&lang=pug"
import script from "./DispatchStatusSelect.vue?vue&type=script&lang=js"
export * from "./DispatchStatusSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5c839e",
  null
  
)

export default component.exports